<template>
  <div
    :class="hasBoxStyle && 'tw-bg-white tw-rounded-[12px] tw-p-8 tw-mt-8'"
    v-for="(snd, index) in fields"
    :key="snd.key"
    :ref="(el) => (itemRefs[index + 1] = el)"
  >
    <div class="tw-flex tw-justify-between tw-items-center tw-mb-5">
      <h3 class="tw-text-base tw-text-static-headerGray">
        اسناد حسابداری ({{ index + 1 }})
      </h3>
      <button
        class="tw-bg-white tw-text-red-500"
        type="button"
        @click="remove_sanad(index)"
      >
        <base-icon icon="trash" class="tw-align-middle" />
        حذف
      </button>
    </div>

    <div class="tw-block md:tw-grid md:tw-grid-cols-12 tw-gap-3 tw-mb-5">
      <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
        <select-codes
          title="بستانکار"
          placeholder="انتخاب بستانکار"
          :additional-options="additional_options"
          :errorMessage="errors['other_sanads[' + index + '].bes_id']"
          :disabled-options="[snd.value.bed_id]"
          v-model="snd.value.bes_id"
        />
      </div>
      <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
        <select-codes
          title="بدهکار"
          placeholder="انتخاب بدهکار"
          :errorMessage="errors['other_sanads[' + index + '].bed_id']"
          :additional-options="additional_options"
          :disabled-options="[snd.value.bes_id]"
          v-model="snd.value.bed_id"
        />
      </div>
      <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
        <input-ayandeh
          v-model:value="snd.value.amount"
          placeholder="وارد کردن مبلغ"
          :errorMessage="errors['other_sanads[' + index + '].amount']"
          :number-format="true"
          float-label="مبلغ (ریال)"
        />
      </div>
    </div>
    <div class="tw-block md:tw-grid md:tw-grid-cols-12 tw-gap-3 tw-mb-5">
      <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
        <base-select
          title="نمایش به باربری"
          placeholder="انتخاب نوع سند"
          :disabled="snd.value.bes_id !== 'car'"
          @change="
            () => {
              if (snd.value.type !== 'from_card_normal')
                snd.value.calc_amount_type = 'by_tonage'
            }
          "
          :float-title="true"
          :errorMessage="errors['other_sanads[' + index + '].type']"
          v-model="snd.value.type"
          :options="sndTypeOpts"
        />
      </div>
      <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
        <base-select
          title="شیوه محاسبه مبلغ سند"
          placeholder="انتخاب شیوه"
          :float-title="true"
          :errorMessage="errors['other_sanads[' + index + '].calc_amount_type']"
          v-model="snd.value.calc_amount_type"
          :options="calcAmountTypeOpts"
        />
      </div>
      <div class="tw-w-full md:tw-col-span-4 tw-mb-6">
        <select-bank-account
          v-if="!(snd.value.bes_id && isNaN(snd.value.bes_id))"
          v-model="snd.value.bank_information_id"
          :accounting_id="snd.value.bes_id"
          :disabled="snd.value.bes_id && isNaN(snd.value.bes_id)"
          :alert="!snd.value.bes_id && 'لطفا ابتدا بستانکار را انتخاب نمایید'"
        >
        </select-bank-account>
      </div>
    </div>
    <div class="tw-gap-3 tw-mb-5">
      <label>شرح سند حسابداری</label>
      <textarea
        cols="3"
        v-model="snd.value.description"
        :ref="(el) => (descRefs[index] = el)"
        placeholder="توضیحات (اختیاری)"
        :class="[
          errors['other_sanads[' + index + '].description']
            ? 'tw-border-red-200'
            : 'tw-border-static-inputBorder',
        ]"
        class="tw-border tw-w-full tw-rounded-[8px] tw-p-1.5 tw-min-h-[70px] placeholder:tw-text-gray-700"
      ></textarea>
      <p
        v-if="errors['other_sanads[' + index + '].description']"
        class="tw-text-red-300 tw-mb-0 tw-text-tiny"
        v-text="errors['other_sanads[' + index + '].description']"
      ></p>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineExpose,
  nextTick,
  watch,
  defineProps,
  defineEmits,
} from 'vue'
import { apiGetSiteUsers } from '@/services/users/Users'
import SelectUsers from '@/components/base/select/SelectUsers.vue'
import BaseIcon from '@/components/base/BaseIcon.vue'
import BaseSelect from '@/components/base/select/BaseSelect.vue'
import InputAyandeh from '@/components/inputs/InputAyandeh.vue'
import NewBtn from '@/components/base/btn/NewBtn.vue'
import AddNewCreditCard from '@/components/bank_informations/AddNewCreditCard.vue'
import SelectBankAccount from '@/components/base/select/SelectBankAccount.vue'
import * as yup from 'yup'
import { useForm, useFieldArray } from 'vee-validate'
import SelectCodes from '@/components/base/select/SelectCodes.vue'

const props = defineProps({
  modelValue: {
    type: Array,
    default: [],
  },
  validated: {
    type: Boolean,
    default: false,
  },
  hasInitialValue: {
    type: Boolean,
    default: false,
  },
  hasBoxStyle: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['update:modelValue', 'update:validated'])

const loadingGetUsers = ref(null)
// const other_sanads = ref([])
const additional_options = [
  {
    label: 'کد حسابداری پلاک',
    value: 'car',
    user_id: 'car',
  },
  {
    label: 'باربری (صادر کننده بارنامه)',
    value: 'freightage',
    user_id: 'freightage',
  },
]
const sndTypeOpts = [
  { value: 'from_card_normal', label: 'عادی - عدم نمایش به باربری' },
  { value: 'from_card_reward', label: 'انعام - نمایش برای باربری' },
  { value: 'from_card_rent', label: 'کرایه - نمایش برای باربری' },
]
const calcAmountTypeOpts = [
  { value: 'static', label: 'مبلغ ثابت' },
  { value: 'by_tonage', label: 'بر اساس تناژ' },
]
const visible_modal_add_credit_card = ref([])

const sanadSchema = yup.lazy((value) => {
  // return yup.object().nullable() // تستی

  // if (isEmptySanad(value)) {
  //   // هیچ اروری ساخته نشه
  //   return yup.object().nullable()
  // }

  // ✅ فقط وقتی کاربر واقعاً چیزی وارد کرده
  return yup.object({
    bes_id: yup.string().required('بستانکار الزامی است'),
    bed_id: yup.string().required('بدهکار الزامی است'),
    type: yup.string().when('bes_id', {
      is: 'car',
      then: (schema) =>
        schema.typeError('نوع سند معتبر نیست').required('نوع سند الزامی است'),
      otherwise: (schema) => schema.nullable(),
    }),
    amount: yup
      .number()
      .typeError('مبلغ معتبر نیست')
      .positive('مبلغ باید مثبت باشد')
      .required('مبلغ الزامی است'),
    calc_amount_type: yup.string().required('شیوه محاسبه مبلغ سند اجباری است'),
    bank_information_id: yup.string().nullable('اصلاعات بانکی اختیاری است'),
    description: yup.string().nullable('توضیحات اختیاری است'),
  })
})

// const sanadSchema = yup.object({
//   bes_id: yup.string().required('بستانکار الزامی است'),
//   bed_id: yup.string().required('بدهکار الزامی است'),
//   type: yup.string().when('bes_id', {
//     is: 'car',
//     then: (schema) =>
//       schema
//         .typeError('نوع سند معتبر نیست')
//         .required('نوع سند الزامی است'),
//     otherwise: (schema) => schema.nullable(),
//   }),
//   amount: yup
//     .number()
//     .typeError('مبلغ معتبر نیست')
//     .positive('مبلغ باید مثبت باشد')
//     .required('مبلغ الزامی است'),
//   calc_amount_type: yup.string().required('شیوه محاسبه مبلغ سند اجباری است'),
//   bank_information: yup.object() .typeError('اصلاعات بانکی معتبر نیست').required('اصلاعات بانکی الزامی است'),
//   description: yup.string().required('توضیحات الزامی است')
// })

const isEmptySanad = (value) => {
  if (!value) return true

  return (
    !value.bes_id &&
    !value.bed_id &&
    !!!value.amount &&
    !!!value.description &&
    !value.bank_information_id
  )
}

const errors = []
const {
  handleSubmit,
  // errors,
  meta,
} = useForm({
  validationSchema: yup.object({
    other_sanads: yup.array().of(sanadSchema),
  }),
  initialValues: {
    other_sanads: [],
  },
})

const { fields, push, remove, replace } = useFieldArray('other_sanads')

defineExpose({
  add_sanad,
})

const itemRefs = ref({})
const descRefs = ref({})

function showModalStoreCreditCard(index) {
  visible_modal_add_credit_card.value[index] = true
}
function hideModalStoreCreditCard(index) {
  visible_modal_add_credit_card.value[index] = false
}
async function getUsers(search = '') {
  loadingGetUsers.value = true
  try {
    const response = await apiGetSiteUsers({
      search: search,
      type: 1,
      paginate: 10,
      page: pageUsers.value,
    })

    if (!response) return
    if (pageUsers.value === 1) {
      users.value = response?.data?.users?.data
    } else {
      users.value = [...users.value, ...response?.data?.users?.data]
    }
    hasNextPageUsers.value = pageUsers.value < response?.data?.users?.last_page
  } catch (error) {
    console.log(error)
  } finally {
    loadingGetUsers.value = false
  }
}

function add_sanad() {
  const index = fields.value.length

  push({
    bed_id: null,
    bes_id: null,
    amount: '',
    calc_amount_type: 'static',
    description: '',
    type: 'from_card_normal',
    bank_information_id: null,
  })

  nextTick(() => {
    scrollToEl(index + 1)
  })
}

async function updateBankInfo(item_num) {
  await nextTick()
  const el = descRefs.value[item_num]
  if (!el) return

  el.focus()
}
const scrollToEl = async (item_num) => {
  await nextTick()
  const el = itemRefs.value[item_num]
  if (!el) return

  el.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  })
}

function remove_sanad(index) {
  remove(index)
  // other_sanads.value.splice(index, 1)
}

// watch(
//   fields,
//   (val) => emit('update:modelValue', val.map(x => x.value)),
//   { deep: true }
// )

let isUpdatingFromParent = false

watch(
  () => props.modelValue,
  (newVal) => {
    isUpdatingFromParent = true
    replace(newVal || [])
    nextTick(() => {
      isUpdatingFromParent = false
    })
  },
  { deep: true, immediate: true },
)

watch(
  fields,
  (val) => {
    if (isUpdatingFromParent) return
    emit(
      'update:modelValue',
      val.map((x) => x.value),
    )
  },
  { deep: true },
)

watch(
  () => meta.value.valid,
  (isValid) => {
    emit('update:validated', isValid)
  },
)
</script>
